import { create } from 'zustand';
import type { OrgBranding } from '@slims/shared/branding';

/**
 * White-label branding della CER di contesto (WB-R22 / ADR-004). Popolato da
 * {@link useCerBrandingSync} (montato una volta nell'app shell) leggendo
 * `GET /api/cer/branding`; consumato da `BrandingEffect` (variabili CSS + font)
 * e dall'header (logo). `null` = brand SLIMS CER di default.
 */
interface BrandingStore {
	branding: OrgBranding | null;
	/** true dopo il primo fetch (a prescindere dall'esito) — evita flash del brand di default. */
	loaded: boolean;
	setBranding: (b: OrgBranding | null) => void;
}

export const useBrandingStore = create<BrandingStore>((set) => ({
	branding: null,
	loaded: false,
	setBranding: (branding) => set({ branding, loaded: true }),
}));
